export const showChat = () => {
  const { $crisp } = window as any;
  $crisp.push(['do', 'chat:show']);
  // Crisp library has a race condition if chat:show and chat:open is called right after another.
  setTimeout(() => {
    $crisp.push(['do', 'chat:open']);
  }, 100);
};
